import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.down("desktop")]: {
            // minHeight: 'calc(100vh - 75px)',
        },
    },
    item: {
        //marginRight: '50%',
    },
    rtlItem: {
        marginRight: 20,
    },

    content: {
        width: "100%",
    },
    description: {
        marginTop: 24,
        display: "block",
        [theme.breakpoints.down("desktop")]: {
            fontSize: theme.fontSizes.md,
            marginTop: 8,
        },
    },
    tabsContainer: {
        marginTop: 28,
        [theme.breakpoints.down("desktop")]: {
            marginTop: 12,
        },
    },

    titles_container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "24px",
    },

    textSmallWidth: {
        width: "350px",
    },
}));

export default useStyles;
